import { QuestionHotelInfo } from "@/components/features/items/edit/hotel-policy/_shared/components/main/question/hotel-info/root";

import { useHotelInfoOfHotelPolicyI18n } from "./hooks";

export const QuestionHotelPolicyI18nHotelInfo = () => {
	const {
		hotelInfo,
		append,
		removeHotelInfoByIndex,
		reorderHotelInfo,
		updateTitle,
		updateDescription,
	} = useHotelInfoOfHotelPolicyI18n();

	return (
		<QuestionHotelInfo
			hotelInfo={hotelInfo}
			appendHotelInfo={append}
			removeHotelInfo={removeHotelInfoByIndex}
			reorderHotelInfo={reorderHotelInfo}
			changeHotelInfoTitle={updateTitle}
			changeHotelInfoDescription={updateDescription}
		/>
	);
};

QuestionHotelPolicyI18nHotelInfo.displayName = "QuestionHotelPolicyI18nHotelInfo";
